// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modalContent_analytics_container__bFtz0 {
  width: 100%;
  height: 100%;
  border: 1px solid var(--sb-border-color);
  border-left: none;
  border-top: none;
}
.modalContent_analytics_container__bFtz0 .modalContent_button__B8vJQ {
  margin: 0 23px 25px;
}
@media screen and (max-width: 781px) {
  .modalContent_analytics_container__bFtz0 .modalContent_button__B8vJQ button {
    width: 100% !important;
    right: 0;
    margin-top: 17px;
    margin-left: 0 !important;
    text-align: center !important;
  }
}
@media screen and (max-width: 781px) {
  .modalContent_analytics_container__bFtz0 {
    border: none;
  }
}
.modalContent_analytics_container__bFtz0 .modalContent_plan__DilDg {
  height: 106px;
  border-radius: 12px;
  border: 1px solid var(--re-border-color);
  display: flex;
  flex-wrap: wrap;
  padding: 15px 18px 20px;
}
@media (max-width: 781px) {
  .modalContent_analytics_container__bFtz0 .modalContent_plan__DilDg {
    height: 189px;
  }
}
.modalContent_analytics_container__bFtz0 .modalContent_plan__DilDg .modalContent_bland__YniNY {
  width: 50%;
}
.modalContent_analytics_container__bFtz0 .modalContent_plan__DilDg .modalContent_bland__YniNY .modalContent_bland_icon__Ey5FE {
  display: flex;
}
.modalContent_analytics_container__bFtz0 .modalContent_plan__DilDg .modalContent_bland__YniNY span {
  color: var(--font-dark-color);
  font-family: Red Hat Display;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-top: 7px;
}
.modalContent_analytics_container__bFtz0 .modalContent_plan__DilDg .modalContent_bland__YniNY .modalContent_brand_title__GEVku {
  color: var(--font-color);
  font-family: Red Hat Display;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-left: 6px;
}
.modalContent_analytics_container__bFtz0 .modalContent_plan__DilDg .modalContent_bland__YniNY .modalContent_brand_description__aD1J7 {
  font-size: 12px;
  text-align: left;
  font-weight: 500;
  line-height: 14px;
}
.modalContent_analytics_container__bFtz0 .modalContent_plan__DilDg .modalContent_option__7mV3S {
  width: 50%;
}
.modalContent_analytics_container__bFtz0 .modalContent_plan__DilDg .modalContent_option__7mV3S .modalContent_brand_label__h0ftu {
  color: var(--font-color);
  font-family: Red Hat Display;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  float: right;
}
.modalContent_analytics_container__bFtz0 .modalContent_plan__DilDg .modalContent_option__7mV3S select {
  width: 214px;
  height: 42px;
  margin-top: 33px;
  margin-right: -30px;
  float: right;
}
@media screen and (max-width: 781px) {
  .modalContent_analytics_container__bFtz0 .modalContent_plan__DilDg .modalContent_option__7mV3S select {
    width: 100%;
    margin-right: 0;
    margin-top: 10px;
  }
}
@media (max-width: 781px) {
  .modalContent_analytics_container__bFtz0 .modalContent_plan__DilDg .modalContent_bland__YniNY,
  .modalContent_analytics_container__bFtz0 .modalContent_plan__DilDg .modalContent_option__7mV3S {
    width: 100%;
  }
  .modalContent_analytics_container__bFtz0 .modalContent_plan__DilDg .modalContent_option__7mV3S {
    margin-top: 13px;
  }
  .modalContent_analytics_container__bFtz0 .modalContent_plan__DilDg .modalContent_option__7mV3S .modalContent_brand_label__h0ftu {
    float: left;
    margin-left: 5px;
  }
}
.modalContent_analytics_container__bFtz0 .modalContent_data_value__KFt-k {
  width: 100%;
  height: 145px;
  background-color: var(--sb-bg-color);
  border-radius: 12px;
  display: flex;
  flex-wrap: wrap;
  margin-top: 18px;
  padding: 10px;
}
@media screen and (max-width: 781px) {
  .modalContent_analytics_container__bFtz0 .modalContent_data_value__KFt-k {
    height: 241px;
  }
}
.modalContent_analytics_container__bFtz0 .modalContent_data_value__KFt-k .modalContent_data_left__YhNI0,
.modalContent_analytics_container__bFtz0 .modalContent_data_value__KFt-k .modalContent_data_used__Qhrqu {
  width: calc((100% - 4px) / 2);
  height: 100%;
}
@media screen and (max-width: 781px) {
  .modalContent_analytics_container__bFtz0 .modalContent_data_value__KFt-k .modalContent_data_left__YhNI0,
  .modalContent_analytics_container__bFtz0 .modalContent_data_value__KFt-k .modalContent_data_used__Qhrqu {
    width: 100%;
    height: calc((100% - 4px) / 2);
  }
}
.modalContent_analytics_container__bFtz0 .modalContent_data_value__KFt-k .modalContent_data_left__YhNI0 {
  border-radius: 12px;
  background: var(--re-data-left-bg);
  padding: 13px 17px 19px 18px;
  margin-right: 4px;
}
.modalContent_analytics_container__bFtz0 .modalContent_data_value__KFt-k .modalContent_data_left__YhNI0 .modalContent_data_label__4qAWZ {
  width: 100%;
  height: auto;
  display: flex;
  margin-bottom: 3px;
}
.modalContent_analytics_container__bFtz0 .modalContent_data_value__KFt-k .modalContent_data_left__YhNI0 .modalContent_data_label__4qAWZ span {
  color: #FFA329;
  font-family: Red Hat Display;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.modalContent_analytics_container__bFtz0 .modalContent_data_value__KFt-k .modalContent_data_left__YhNI0 .modalContent_data_label__4qAWZ .modalContent_left_rate__Zh8CK {
  width: auto;
  height: 24px;
  background: var(--re-rate-bg);
  border-radius: 8px;
  display: flex;
  margin-left: auto;
  padding: 4px 3.27px 4px 4px;
  align-items: center;
  gap: 4px;
}
.modalContent_analytics_container__bFtz0 .modalContent_data_value__KFt-k .modalContent_data_left__YhNI0 .modalContent_data_label__4qAWZ .modalContent_left_rate__Zh8CK span {
  color: #FF6A55;
  font-family: Red Hat Display;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: -0.15px;
}
.modalContent_analytics_container__bFtz0 .modalContent_data_value__KFt-k .modalContent_data_left__YhNI0 .modalContent_capacity__1bAwC {
  color: var(--font-color);
  font-family: Red Hat Display;
  font-size: 36px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
@media screen and (max-width: 781px) {
  .modalContent_analytics_container__bFtz0 .modalContent_data_value__KFt-k .modalContent_data_left__YhNI0 .modalContent_capacity__1bAwC {
    font-size: 26px;
  }
}
.modalContent_analytics_container__bFtz0 .modalContent_data_value__KFt-k .modalContent_data_left__YhNI0 .modalContent_progress__SdnTy {
  width: 100%;
  height: 10px;
  background-color: var(--re-progress-bg);
  border-radius: 32px;
  margin-top: 12px;
}
.modalContent_analytics_container__bFtz0 .modalContent_data_value__KFt-k .modalContent_data_left__YhNI0 .modalContent_progress__SdnTy div {
  width: 56%;
  height: 100%;
  background: linear-gradient(221deg, #EA50BF -27.22%, #FFA329 76.94%), linear-gradient(279deg, #3A37D1 -27.51%, #EA50BF 89.56%), #D9D9D9;
  border-radius: 32px;
}
.modalContent_analytics_container__bFtz0 .modalContent_data_value__KFt-k .modalContent_data_used__Qhrqu {
  padding: 13px 17px 19px 18px;
}
@media screen and (max-width: 781px) {
  .modalContent_analytics_container__bFtz0 .modalContent_data_value__KFt-k .modalContent_data_used__Qhrqu div {
    margin-bottom: 6px;
  }
}
.modalContent_analytics_container__bFtz0 .modalContent_data_value__KFt-k .modalContent_data_used__Qhrqu .modalContent_data_label__4qAWZ {
  width: 100%;
  height: auto;
  display: flex;
  margin-bottom: 16px;
}
@media screen and (max-width: 781px) {
  .modalContent_analytics_container__bFtz0 .modalContent_data_value__KFt-k .modalContent_data_used__Qhrqu .modalContent_data_label__4qAWZ {
    margin-bottom: 12px;
  }
}
.modalContent_analytics_container__bFtz0 .modalContent_data_value__KFt-k .modalContent_data_used__Qhrqu .modalContent_data_label__4qAWZ span {
  color: var(--font-color);
  font-family: Red Hat Display;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.modalContent_analytics_container__bFtz0 .modalContent_data_value__KFt-k .modalContent_data_used__Qhrqu .modalContent_data_label__4qAWZ .modalContent_left_rate__Zh8CK {
  width: auto;
  height: 24px;
  background: var(--re-rate-bg);
  border-radius: 8px;
  display: flex;
  margin-left: auto;
  padding: 4px 3.27px 4px 4px;
  align-items: center;
  gap: 4px;
}
.modalContent_analytics_container__bFtz0 .modalContent_data_value__KFt-k .modalContent_data_used__Qhrqu .modalContent_data_label__4qAWZ .modalContent_left_rate__Zh8CK span {
  color: #FF6A55;
  font-family: Red Hat Display;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: -0.15px;
}
.modalContent_analytics_container__bFtz0 .modalContent_data_value__KFt-k .modalContent_data_used__Qhrqu .modalContent_today__-kaC1 {
  color: #7C7C7D;
  font-family: Red Hat Display;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.modalContent_analytics_container__bFtz0 .modalContent_data_value__KFt-k .modalContent_data_used__Qhrqu .modalContent_capacity__1bAwC {
  color: var(--font-color);
  font-family: Red Hat Display;
  font-size: 36px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
@media screen and (max-width: 781px) {
  .modalContent_analytics_container__bFtz0 .modalContent_data_value__KFt-k .modalContent_data_used__Qhrqu .modalContent_capacity__1bAwC {
    font-size: 26px;
  }
}
.modalContent_analytics_container__bFtz0 .modalContent_horizontal__v9SZI {
  width: 100%;
  height: 1px;
  background-color: var(--re-horizontal-bg);
  margin-top: 19px;
}
@media screen and (max-width: 781px) {
  .modalContent_analytics_container__bFtz0 .modalContent_horizontal__v9SZI {
    display: none;
  }
}
@media screen and (max-width: 781px) {
  .modalContent_analytics_container__bFtz0 .modalContent_proxy_container__qXEqA {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Layouts/DetailModal/ModalContent/modalContent.module.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,wCAAA;EACA,iBAAA;EACA,gBAAA;AACJ;AACI;EACI,mBAAA;AACR;AACQ;EACI;IACI,sBAAA;IACA,QAAA;IACA,gBAAA;IACA,yBAAA;IACA,6BAAA;EACd;AACF;AAGI;EArBJ;IAsBQ,YAAA;EAAN;AACF;AAEI;EACI,aAAA;EACA,mBAAA;EACA,wCAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;AAAR;AAEQ;EARJ;IASQ,aAAA;EACV;AACF;AACQ;EACI,UAAA;AACZ;AACY;EACI,aAAA;AAChB;AAEY;EACI,6BAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AAAhB;AAGY;EACI,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AADhB;AAIY;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AAFhB;AAMQ;EACI,UAAA;AAJZ;AAMY;EACI,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;AAJhB;AAOY;EACI,YAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;AALhB;AAOgB;EAPJ;IAQQ,WAAA;IACA,eAAA;IACA,gBAAA;EAJlB;AACF;AAQQ;EACI;;IAEI,WAAA;EANd;EASU;IACI,gBAAA;EAPd;EASc;IACI,WAAA;IACA,gBAAA;EAPlB;AACF;AAYI;EACI,WAAA;EACA,aAAA;EACA,oCAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;AAVR;AAYQ;EAVJ;IAWQ,aAAA;EATV;AACF;AAWQ;;EAEI,6BAAA;EACA,YAAA;AATZ;AAWY;EALJ;;IAMQ,WAAA;IACA,8BAAA;EAPd;AACF;AAUQ;EACI,mBAAA;EACA,kCAAA;EACA,4BAAA;EACA,iBAAA;AARZ;AAUY;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AARhB;AAUgB;EACI,cAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AARpB;AAWgB;EACI,WAAA;EACA,YAAA;EACA,6BAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,2BAAA;EACA,mBAAA;EACA,QAAA;AATpB;AAWoB;EACI,cAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;AATxB;AAcY;EACI,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAZhB;AAcgB;EARJ;IASQ,eAAA;EAXlB;AACF;AAcY;EACI,WAAA;EACA,YAAA;EACA,uCAAA;EACA,mBAAA;EACA,gBAAA;AAZhB;AAcgB;EACI,UAAA;EACA,YAAA;EACA,uIAAA;EACA,mBAAA;AAZpB;AAiBQ;EACI,4BAAA;AAfZ;AAiBY;EACI;IACI,kBAAA;EAflB;AACF;AAkBY;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AAhBhB;AAkBgB;EANJ;IAOQ,mBAAA;EAflB;AACF;AAiBgB;EACI,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAfpB;AAkBgB;EACI,WAAA;EACA,YAAA;EACA,6BAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,2BAAA;EACA,mBAAA;EACA,QAAA;AAhBpB;AAkBoB;EACI,cAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;AAhBxB;AAqBY;EACI,cAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAnBhB;AAsBY;EACI,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AApBhB;AAsBgB;EARJ;IASQ,eAAA;EAnBlB;AACF;AAwBI;EACI,WAAA;EACA,WAAA;EACA,yCAAA;EACA,gBAAA;AAtBR;AAwBQ;EANJ;IAOQ,aAAA;EArBV;AACF;AAyBQ;EADJ;IAEQ,aAAA;EAtBV;AACF","sourcesContent":[".analytics_container {\n    width: 100%;\n    height: 100%;\n    border: 1px solid var(--sb-border-color);\n    border-left: none;\n    border-top: none;\n\n    .button {\n        margin: 0 23px 25px;\n\n        @media screen and (max-width: 781px) {\n            button {\n                width: 100% !important;\n                right: 0;\n                margin-top: 17px;\n                margin-left: 0 !important;\n                text-align: center !important;\n            }\n        }\n    }\n\n    @media screen and (max-width: 781px) {\n        border: none;\n    }\n\n    .plan {\n        height: 106px;\n        border-radius: 12px;\n        border: 1px solid var(--re-border-color);\n        display: flex;\n        flex-wrap: wrap;\n        padding: 15px 18px 20px;\n\n        @media (max-width: 781px) {\n            height: 189px;\n        }\n\n        .bland {\n            width: 50%;\n\n            .bland_icon {\n                display: flex;\n            }\n\n            span {\n                color: var(--font-dark-color);\n                font-family: Red Hat Display;\n                font-size: 12px;\n                font-style: normal;\n                font-weight: 500;\n                line-height: normal;\n                margin-top: 7px;\n            }\n\n            .brand_title {\n                color: var(--font-color);\n                font-family: Red Hat Display;\n                font-size: 20px;\n                font-style: normal;\n                font-weight: 700;\n                line-height: normal;\n                margin-left: 6px;\n            }\n\n            .brand_description {\n                font-size: 12px;\n                text-align: left;\n                font-weight: 500;\n                line-height: 14px;\n            }\n        }\n\n        .option {\n            width: 50%;\n\n            .brand_label {\n                color: var(--font-color);\n                font-family: Red Hat Display;\n                font-size: 14px;\n                font-style: normal;\n                font-weight: 700;\n                line-height: normal;\n                float: right;\n            }\n\n            select {\n                width: 214px;\n                height: 42px;\n                margin-top: 33px;\n                margin-right: -30px;\n                float: right;\n\n                @media screen and (max-width: 781px) {\n                    width: 100%;\n                    margin-right: 0;\n                    margin-top: 10px;\n                }\n            }\n        }\n\n        @media (max-width: 781px) {\n            .bland,\n            .option {\n                width: 100%;\n            }\n\n            .option {\n                margin-top: 13px;\n\n                .brand_label {\n                    float: left;\n                    margin-left: 5px;\n                }\n            }\n        }\n    }\n\n    .data_value {\n        width: 100%;\n        height: 145px;\n        background-color: var(--sb-bg-color);\n        border-radius: 12px;\n        display: flex;\n        flex-wrap: wrap;\n        margin-top: 18px;\n        padding: 10px;\n\n        @media screen and (max-width: 781px) {\n            height: 241px;\n        }\n\n        .data_left,\n        .data_used {\n            width: calc((100% - 4px) / 2);\n            height: 100%;\n\n            @media screen and (max-width: 781px) {\n                width: 100%;\n                height: calc((100% - 4px) / 2);\n            }\n        }\n\n        .data_left {\n            border-radius: 12px;\n            background: var(--re-data-left-bg);\n            padding: 13px 17px 19px 18px;\n            margin-right: 4px;\n\n            .data_label {\n                width: 100%;\n                height: auto;\n                display: flex;\n                margin-bottom: 3px;\n\n                span {\n                    color: #FFA329;\n                    font-family: Red Hat Display;\n                    font-size: 15px;\n                    font-style: normal;\n                    font-weight: 700;\n                    line-height: normal;\n                }\n\n                .left_rate {\n                    width: auto;\n                    height: 24px;\n                    background: var(--re-rate-bg);\n                    border-radius: 8px;\n                    display: flex;\n                    margin-left: auto;\n                    padding: 4px 3.27px 4px 4px;\n                    align-items: center;\n                    gap: 4px;\n\n                    span {\n                        color: #FF6A55;\n                        font-family: Red Hat Display;\n                        font-size: 12px;\n                        font-style: normal;\n                        font-weight: 700;\n                        line-height: 16px;\n                        letter-spacing: -0.15px;\n                    }\n                }\n            }\n\n            .capacity {\n                color: var(--font-color);\n                font-family: Red Hat Display;\n                font-size: 36px;\n                font-style: normal;\n                font-weight: 700;\n                line-height: normal;\n\n                @media screen and (max-width: 781px) {\n                    font-size: 26px;\n                }\n            }\n\n            .progress {\n                width: 100%;\n                height: 10px;\n                background-color: var(--re-progress-bg);\n                border-radius: 32px;\n                margin-top: 12px;\n\n                div {\n                    width: 56%;\n                    height: 100%;\n                    background: linear-gradient(221deg, #EA50BF -27.22%, #FFA329 76.94%), linear-gradient(279deg, #3A37D1 -27.51%, #EA50BF 89.56%), #D9D9D9;\n                    border-radius: 32px;\n                }\n            }\n        }\n\n        .data_used {\n            padding: 13px 17px 19px 18px;\n\n            @media screen and (max-width: 781px){\n                div {\n                    margin-bottom: 6px;\n                }\n            }\n\n            .data_label {\n                width: 100%;\n                height: auto;\n                display: flex;\n                margin-bottom: 16px;\n\n                @media screen and (max-width: 781px) {\n                    margin-bottom: 12px;\n                }\n\n                span {\n                    color: var(--font-color);\n                    font-family: Red Hat Display;\n                    font-size: 15px;\n                    font-style: normal;\n                    font-weight: 700;\n                    line-height: normal;\n                }\n\n                .left_rate {\n                    width: auto;\n                    height: 24px;\n                    background: var(--re-rate-bg);\n                    border-radius: 8px;\n                    display: flex;\n                    margin-left: auto;\n                    padding: 4px 3.27px 4px 4px;\n                    align-items: center;\n                    gap: 4px;\n\n                    span {\n                        color: #FF6A55;\n                        font-family: Red Hat Display;\n                        font-size: 12px;\n                        font-style: normal;\n                        font-weight: 700;\n                        line-height: 16px;\n                        letter-spacing: -0.15px;\n                    }\n                }\n            }\n\n            .today {\n                color: #7C7C7D;\n                font-family: Red Hat Display;\n                font-size: 16px;\n                font-style: normal;\n                font-weight: 600;\n                line-height: normal;\n            }\n\n            .capacity {\n                color: var(--font-color);\n                font-family: Red Hat Display;\n                font-size: 36px;\n                font-style: normal;\n                font-weight: 700;\n                line-height: normal;\n\n                @media screen and (max-width: 781px) {\n                    font-size: 26px;\n                }\n            }\n        }\n    }\n\n    .horizontal {\n        width: 100%;\n        height: 1px;\n        background-color: var(--re-horizontal-bg);\n        margin-top: 19px;\n\n        @media screen and (max-width: 781px) {\n            display: none;\n        }\n    }\n\n    .proxy_container {\n        @media screen and (max-width: 781px) {\n            display: none;\n        }\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"analytics_container": `modalContent_analytics_container__bFtz0`,
	"button": `modalContent_button__B8vJQ`,
	"plan": `modalContent_plan__DilDg`,
	"bland": `modalContent_bland__YniNY`,
	"bland_icon": `modalContent_bland_icon__Ey5FE`,
	"brand_title": `modalContent_brand_title__GEVku`,
	"brand_description": `modalContent_brand_description__aD1J7`,
	"option": `modalContent_option__7mV3S`,
	"brand_label": `modalContent_brand_label__h0ftu`,
	"data_value": `modalContent_data_value__KFt-k`,
	"data_left": `modalContent_data_left__YhNI0`,
	"data_used": `modalContent_data_used__Qhrqu`,
	"data_label": `modalContent_data_label__4qAWZ`,
	"left_rate": `modalContent_left_rate__Zh8CK`,
	"capacity": `modalContent_capacity__1bAwC`,
	"progress": `modalContent_progress__SdnTy`,
	"today": `modalContent_today__-kaC1`,
	"horizontal": `modalContent_horizontal__v9SZI`,
	"proxy_container": `modalContent_proxy_container__qXEqA`
};
export default ___CSS_LOADER_EXPORT___;
